export interface Question {
  id: string;
  question: string;
  text?: string; // Keep for backward compatibility
  options: string[];
  answer: string;
  correctOption?: string;
  imageUrl?: string;
  subject?: string;
  year?: string | number;
}

export interface FormattedQuestion extends Question {
  text?: string;
}

export type Subject = 'mathematics' | 'english' | 'physics' | 'chemistry' | 'biology';

export interface SubjectData {
  [year: string]: Question[];
}

// Add a utility function for subject name formatting
export const formatSubjectName = (subject: string): Subject => {
  return subject.toLowerCase() as Subject;
}; 